<div class="settings-container">
  <app-header-actions
    [headerIcon]="faCog"
    [headerTitle]="'SECTION.SETTINGS'"
    [config]="headerConfig"
    [initialFilters]="currentFilters"
    (filtersChanged)="onFiltersChanged($event)"
    (searchCleared)="onSearchCleared()"
    (allFiltersCleared)="onAllFiltersCleared()">
  </app-header-actions>

  <div class="language-settings">
    <div class="settings-group">
      <label for="language-select">{{ 'HEADER.LANGUAGE' | translate }}:</label>
      <ng-select
        id="language-select"
        [(ngModel)]="currentLanguage"
        (ngModelChange)="changeLanguage($event)"
        [items]="languageOptions"
        bindLabel="label"
        bindValue="value"
        [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
        [clearable]="false"
        [searchable]="false"
        class="language-select">
      </ng-select>
    </div>

    <div class="settings-group">
      <label for="theme-select">{{ 'HEADER.THEME' | translate }}:</label>
      <ng-select
        id="theme-select"
        [(ngModel)]="currentTheme"
        (ngModelChange)="changeTheme($event)"
        [items]="themeOptions"
        bindLabel="label"
        bindValue="value"
        [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
        [clearable]="false"
        [searchable]="false"
        class="theme-select">
        <ng-template ng-label-tmp let-item="item">
          <fa-icon [icon]="item.value === 'light' ? faSun : faMoon"></fa-icon>
          {{ item.label | translate }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <fa-icon [icon]="item.value === 'light' ? faSun : faMoon"></fa-icon>
          {{ item.label | translate }}
        </ng-template>
      </ng-select>
    </div>

    @if (isAdmin) {
      <div class="settings-group">
        <label for="max-simulation-files-select">{{ 'SETTINGS.PREFERENCES.MAX_SIMULATION_FILES' | translate }}:</label>
        <ng-select
          id="max-simulation-files-select"
          [(ngModel)]="maxSimulationFiles"
          (ngModelChange)="changeMaxSimulationFiles($event)"
          [items]="maxSimulationFilesOptions"
          [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
          [clearable]="false"
          [searchable]="false"
          class="max-files-select">
        </ng-select>
      </div>
    }
  </div>

  <div class="settings-list">
    @for (setting of filteredSettings; track trackById($index, setting)) {
      @if (setting.enabled) {
        <div
          class="setting-item"
          (click)="navigateToSetting(setting)"
          >
          <div class="setting-content">
            <fa-icon [icon]="setting.icon" class="setting-icon"></fa-icon>
            <div class="setting-info">
              <div class="setting-name">{{ setting.name }}</div>
              <div class="setting-description">{{ setting.description }}</div>
            </div>
          </div>
          <div class="setting-actions">
            <fa-icon [icon]="faChevronRight" class="chevron-icon"></fa-icon>
          </div>
        </div>
      }
    }

    @if (filteredSettings.length === 0) {
      <div class="empty-message">
        <fa-icon [icon]="faCog" class="empty-icon"></fa-icon>
        @if (searchTerm) {
          <span>{{ 'MESSAGE.NO.SETTINGS.SEARCH' | translate:{ searchTerm: searchTerm } }}</span>
        }
        @if (!searchTerm) {
          <span>{{ 'MESSAGE.NO.SETTINGS' | translate }}</span>
        }
      </div>
    }
  </div>
</div>